import { compose } from 'redux';
import { reset } from 'redux-form';
import { connect } from 'react-redux';
import { LOGIN } from '../../../constants/formNamesConstants';
import ContactUs from '../components/ContactUs';
import { fillLoginForm } from '../../../common/debug/utils';

const mapDispatchToProps = (dispatch) => ({
  fillForm: () => {
    fillLoginForm(dispatch);
  },
  clearForm: () => dispatch(reset(LOGIN)),
});

const connectToStore = connect(null, mapDispatchToProps);

export default compose(connectToStore)(ContactUs);
